<template>
  <transition name="modal" v-if="isReady">
    <div class="modal fade show modal-container" :id="modalId">
      <div class="modal-dialog" :class="sizeClass">
        <div class="modal-content">
          <slot name="body" >
            ...
          </slot>

          <a href="#close-modal" data-dismiss="modal" rel="modal:close" class="close-modal "  @click="$emit('close')">Close</a>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
      name: 'Modal',

      props: {
        size: {
          required: false,
          type: String,
        },

        id: {
          type: String,
        },
      },

      data() {
        return {
          isReady: false,
        }
      },

      mounted() {
        // Create and append backdrop
        let modalBackdrop = document.createElement('div')
        modalBackdrop.setAttribute('id', 'modal-backdrop')
        modalBackdrop.classList.add(`modal-backdrop`)
        modalBackdrop.classList.add(`show`)
        document.body.appendChild(modalBackdrop)
        
        // Add modal-open class to body
        document.body.classList.add('modal-open')
        
        // Move modal to body
        document.body.appendChild(this.$el)
        
        this.$nextTick(() => {
          this.isReady = true
        })
      },

      created() {
        document.addEventListener('keyup', this.escapeKeyListener)
      },

      beforeDestroy() {
        this.cleanup()
      },
      
      beforeUnmount() {
        // Vue 3 compatibility
        this.cleanup()
      },
      
      unmounted() {
        // Vue 3 - additional cleanup in case beforeUnmount didn't complete
        this.cleanup()
      },

      computed: {
        hasFooterSlot() {
          return !!this.$slots['footer']
        },

        sizeClass() {
          if (this.size) {
            return `modal-${this.size}`
          }
        },

        modalId() {
          if (this.id) {
            return this.id
          }
          return ''
        },
      },

      methods: {
        escapeKeyListener: function(event) {
          if (event.keyCode === 27) {
            this.$emit('close')
          }
        },
        
        cleanup() {
          // Remove modal-open class from body
          document.body.classList.remove('modal-open')
          
          // Remove backdrop
          const backdrop = document.getElementById('modal-backdrop')
          if (backdrop && backdrop.parentNode) {
            backdrop.parentNode.removeChild(backdrop)
          }
          
          // Remove event listener
          document.removeEventListener('keyup', this.escapeKeyListener)
          
          // Remove modal element from body if it was moved there
          if (this.$el && this.$el.parentNode === document.body) {
            try {
              document.body.removeChild(this.$el)
            } catch (e) {
              // Element might already be removed
            }
          }
        }
      },
    }
</script>

<style scoped lang="scss">
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;

    &.modal-fullscreen {
      /* in full screen we switch to flex */
      display: flex;
      .modal-dialog {
        width: 100%;
        //height: 100%;
        margin: 0;
        padding: 0;
        max-width: none;
      }

      .modal-content {
        height: auto;
        min-height: 100%;
        border-radius: 0;
        border: none;
      }
    }
  }
  
  .modal-dialog {
    position: relative;
    width: auto;
    margin: 1.75rem auto;
    pointer-events: none;
    max-width: 500px;
  }
  
  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.5rem;
    outline: 0;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .modal-mask {
    /*position: fixed;*/
    /*z-index: 9998;*/
    /*top: 0;*/
    /*left: 0;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*background-color: rgba(0, 0, 0, .5);*/
    /*display: table;*/
    transition: opacity .3s ease;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }


  a.close-modal {
    position: absolute;
    top: -7.5px;
    right: -7.5px;
    display: block;
    width: 25px;
    height: 25px;
    z-index: 999;
    text-indent: -9999px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    /*background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAA3hJREFUaAXlm8+K00Acx7MiCIJH/yw+gA9g25O49SL4AO3Bp1jw5NvktC+wF88qevK4BU97EmzxUBCEolK/n5gp3W6TTJPfpNPNF37MNsl85/vN/DaTmU6PknC4K+pniqeKJ3k8UnkvDxXJzzy+q/yaxxeVHxW/FNHjgRSeKt4rFoplzaAuHHDBGR2eS9G54reirsmienDCTRt7xwsp+KAoEmt9nLaGitZxrBbPFNaGfPloGw2t4JVamSt8xYW6Dg1oCYo3Yv+rCGViV160oMkcd8SYKnYV1Nb1aEOjCe6L5ZOiLfF120EjWhuBu3YIZt1NQmujnk5F4MgOpURzLfAwOBSTmzp3fpDxuI/pabxpqOoz2r2HLAb0GMbZKlNV5/Hg9XJypguryA7lPF5KMdTZQzHjqxNPhWhzIuAruOl1eNqKEx1tSh5rfbxdw7mOxCq4qS68ZTjKS1YVvilu559vWvFHhh4rZrdyZ69Vmpgdj8fJbDZLJpNJ0uv1cnr/gjrUhQMuI+ANjyuwftQ0bbL6Erp0mM/ny8Fg4M3LtdRxgMtKl3jwmIHVxYXChFy94/Rmpa/pTbNUhstKV+4Rr8lLQ9KlUvJKLyG8yvQ2s9SBy1Jb7jV5a0yapfF6apaZLjLLcWtd4sNrmJUMHyM+1xibTjH82Zh01TNlhsrOhdKTe00uAzZQmN6+KW+sDa/JD2PSVQ873m29yf+1Q9VDzfEYlHi1G5LKBBWZbtEsHbFwb1oYDwr1ZiF/2bnCSg1OBE/pfr9/bWx26UxJL3ONPISOLKUvQza0LZUxSKyjpdTGa/vDEr25rddbMM0Q3O6Lx3rqFvU+x6UrRKQY7tyrZecmD9FODy8uLizTmilwNj0kraNcAJhOp5aGVwsAGD5VmJBrWWbJSgWT9zrzWepQF47RaGSiKfeGx6Szi3gzmX/HHbihwBser4B9UJYpFBNX4R6vTn3VQnez0SymnrHQMsRYGTr1dSk34ljRqS/EMd2pLQ8YBp3a1PLfcqCpo8gtHkZFHKkTX6fs3MY0blKnth66rKCnU0VRGu37ONrQaA4eZDFtWAu2fXj9zjFkxTBOo8F7t926gTp/83Kyzzcy2kZD6xiqxTYnHLRFm3vHiRSwNSjkz3hoIzo8lCKWUlg/YtGs7tObunDAZfpDLbfEI15zsEIY3U/x/gHHc/G1zltnAgAAAABJRU5ErkJggg==");*/
  }
  @media only screen and (min-width: 768px) {
    a.close-modal {
      top: -12.5px;
      right: -12.5px;
      width: 30px;
      height: 30px;
    }
  }


  #donate a.close-modal {
    display: block;
  }
  
  // Global styles for modal backdrop
  :global(.modal-backdrop) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  :global(.modal-open) {
    overflow: hidden;
  }


</style>
